import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

const EmptyIcon = (props: IconProps) => <IconBox {...props} />;

export default EmptyIcon;
